import { create } from 'zustand';

type Tab =
  | 'details'
  | 'fees'
  | 'documents'
  | 'inspection'
  | 'pledge'
  | 'approval-history'
  | 'audit';

interface PermitDetailStore {
  activeTab: Tab;
  approveModal: boolean;
  rejectModal: boolean;
  deleteModal: boolean;
  actionError: string | null;
  setActiveTab: (tab: Tab) => void;
  setApproveModal: (open: boolean) => void;
  setRejectModal: (open: boolean) => void;
  setDeleteModal: (open: boolean) => void;
  setActionError: (error: string | null) => void;
  reset: () => void;
}

const INITIAL: Omit<
  PermitDetailStore,
  keyof Omit<
    PermitDetailStore,
    'activeTab' | 'approveModal' | 'rejectModal' | 'deleteModal' | 'actionError'
  >
> = {
  activeTab: 'details',
  approveModal: false,
  rejectModal: false,
  deleteModal: false,
  actionError: null,
};

export const usePermitDetailStore = create<PermitDetailStore>((set) => ({
  ...INITIAL,
  setActiveTab: (tab) => set({ activeTab: tab }),
  setApproveModal: (open) => set({ approveModal: open }),
  setRejectModal: (open) => set({ rejectModal: open }),
  setDeleteModal: (open) => set({ deleteModal: open }),
  setActionError: (error) => set({ actionError: error }),
  reset: () =>
    set({
      activeTab: 'details',
      approveModal: false,
      rejectModal: false,
      deleteModal: false,
      actionError: null,
    }),
}));
